<template>
  <button @click="handleSelected">
    <span v-if="multiple" class="select" :class="{ active }" />
    <div class="content">
      <div class="text">
        <img src="@/assets/images/icons/adwords.svg" alt="adwords logo" loading="eager">
        {{ name }}
      </div>
      <span class="id">{{ id }}</span>
    </div>
  </button>
</template>

<script>
export default {
  name: "AdwordsIdBtn",
  props: {
    item: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    name() {
      const defaultName = 'Google Ads account';
      return Object.values( this.item )[0] || defaultName;
    },

    id() {
      return Object.keys( this.item )[0]
    }
  },
  methods: {
    handleSelected() {
      this.$emit('selected', this.item);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

button {
  position: relative;
  display: flex;
  align-items: center;
  text-align: left;
  background: $white;
  border: 3px solid $orange;
  border-radius: 50px;
  padding: 16px 40px 16px 85px;
  width: 350px;
  height: 82px;
  max-width: 98% ;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0px 0px 10px #2E231D26;
  overflow: hidden;

  @include xs {
    padding: 12px 20px 12px 44px;
  }
}
.select {
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);
  height: 22px;
  width: 22px;
  border: 1px solid $darkGray;
  background: $white;
  border-radius: 50px;

  @include xs {
    height: 15px;
    width: 15px;
    left: 20px;
  }
  &.active {
    background: $orange;
    border: 1px solid $orange;
  }
}
.content {
  max-width: 100%;
}
.text {
  font-family: "Sofia Pro";
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  img {
    height: 14px;
    margin-right: 4px;
  }
}
.id {
  font-family: "Sofia Pro Light";
  font-size: 16px;
  color: $black;
}
</style>